import "./SurveyTeamTabPage.scss";

import { Text } from "@fluentui/react-northstar";
import { getImageCardUrl } from "@teams/cards";
import { TeamsApplicationTypes } from "@teams/types";
import React from "react";
import { useParams } from "react-router";

import { GenericSurveyTabPage } from "../../_shared/components/GenericSurveyTabPage";
import { ChannelTabNavigationItems } from "../../_shared/components/NavigationHeader";
import { useTeamsContext } from "../../_shared/state/TeamsContextProvider";
import { ContentScope } from "../actions/useChannelSurveys";
import { MeetingsTabPage } from "./Meetings/MeetingsTabPage";

export const SurveyTeamTabPage: React.FC = () => {
  const { scope } = useParams<{ scope: ContentScope }>();
  const { teamsContext } = useTeamsContext();

  // For group chat meeting, need to show the meeting sidepanel UI
  if (teamsContext.meeting?.id) {
    return <MeetingsTabPage />;
  }

  return (
    <>
      <GenericSurveyTabPage
        loadingMessage="Loading Pollys ..."
        showSurveys
        showSchedules
        pageName={teamsContext?.chat?.id ? "chat" : "team"}
        scope={scope}
        navigationItems={ChannelTabNavigationItems}
        noResultsContent={
          <SurveyTeamTabNoResults
            applicationType="msteams"
            channelName={teamsContext.channel?.displayName}
          />
        }
      />
    </>
  );
};

type SurveyTeamTabNoResultsParams = {
  applicationType: TeamsApplicationTypes;
  channelName: string | undefined;
};
const SurveyTeamTabNoResults: React.FC<SurveyTeamTabNoResultsParams> = ({
  applicationType,
  channelName,
}) => {
  return (
    <div className="survey-team-tab-page__missing-container">
      <Text
        className="survey-team-tab-page__no-survey"
        size="larger"
        weight="bold"
        as="div"
        align="center"
      >
        No Pollys for {channelName} yet!
      </Text>

      <Text className="survey-team-tab-page__no-survey" size="medium" as="div" align="center">
        Get started by selecting "Create" above!
      </Text>

      <img
        className="survey-team-tab-page__missing-item-image"
        src={getImageCardUrl("EMPTY", applicationType)}
        alt="Missing item"
      ></img>
    </div>
  );
};
